import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RolesService {

  public roles$: BehaviorSubject<Array<string>> = new BehaviorSubject(null);

  getRoles(): Observable<Array<string>> {
    return this.roles$.asObservable();
  }

  setRoles(roles: Array<string>) {
      this.roles$.next(roles);
  }

}


